{
  "title": "Skills",
  "subtitle": "Wiederverwendbare Anweisungs-Templates für deine Agenten",
  "new": "Neuer Skill",
  "new_title": "Neuer Skill",
  "edit_title": "Skill bearbeiten: {{name}}",
  "delete_confirm": "Skill \"{{name}}\" wirklich löschen?",
  "section_user": "Eigene Skills",
  "section_user_empty": "Noch keine eigenen Skills.",
  "section_system": "System-Skills",
  "section_system_empty": "Keine System-Skills installiert.",
  "name": "Name",
  "name_invalid": "Ungültig — nur a-z, 0-9, _ und -, max 50 Zeichen.",
  "name_immutable": "Name kann nach Anlegen nicht geändert werden.",
  "description": "Beschreibung",
  "description_placeholder": "Worum geht's in dem Skill?",
  "when_to_use": "Wann nutzen?",
  "when_to_use_hint": "Beschreibt der KI in einem Satz wann sie diesen Skill laden sollte.",
  "when_to_use_placeholder": "z.B. 'Wenn der User um Code-Review bittet'",
  "tools_required": "Benötigte Tools (kommagetrennt)",
  "body": "Anweisungen (Markdown)",
  "body_placeholder": "Anweisungen die der Agent beim Laden bekommt…",
  "sources": "Quellen / URLs",
  "sources_hint": "URLs (Foren, APIs, Doku) die der Agent via fetch_url abrufen kann. Auth wird automatisch eingehängt wenn ein Credential-Profil gesetzt ist.",
  "source_description_placeholder": "Beschreibung der Quelle (optional)",
  "source_auth_placeholder": "Profilname",
  "source_auth_hint": "Optional: Name eines Credential-Profils aus /credentials. Erzwingt diese Auth bei fetch_url.",
  "source_add": "Quelle hinzufügen",
  "agent_tab_subtitle": "{{count}} Skills für diesen Agent verfügbar",
  "agent_tab_empty": "Keine Skills verfügbar — leg einen unter /skills oder hier an.",
  "agent_tab_edit": "Bearbeiten",
  "agent_tab_on": "an",
  "agent_tab_off": "aus",
  "project_title": "Projekt-Skills",
  "project_subtitle": "Geteilte Bibliothek: Alle Agenten, die in diesem Projekt arbeiten, sehen diese Skills — Projekt-Agent, Spezialisten und Buddy/Master, wenn das Projekt gewählt ist.",
  "project_empty": "Noch keine Projekt-Skills. Der Projekt-Agent kann sie per write_skill anlegen, oder du legst hier einen an.",
  "project_read_only": "Du hast nur Leserechte in diesem Projekt.",
  "project_load_error": "Projekt-Skills konnten nicht geladen werden."
}
